/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum CheckupTypeItemsListAliases {
  CHECKUP_TYPE_ITEM_CARD_CONTAINER = 'checkup-type-item-card-container',
  CHECKUP_TYPE_ITEM_CARD_CONTAINER_BODY = 'checkup-type-item-card-container-body',
  CHECKUP_TYPE_ITEM_DESCRIPTION_MOBILE_CARD_CONTAINER_ZONE = 'checkup-type-item-description-mobile-card-container-zone',
  CHECKUP_TYPE_ITEM_DESKTOP_DESCRIPTION_CARD_CONTAINER_ZONE = 'checkup-type-item-desktop-description-card-container-zone',
  CHECKUP_TYPE_ITEM_DESKTOP_EXPECTED_DATE_CARD_CONTAINER_ZONE = 'checkup-type-item-desktop-expected-date-card-container-zone',
  CHECKUP_TYPE_ITEM_DESKTOP_PHYSICIAN_CARD_CONTAINER_ZONE = 'checkup-type-item-desktop-physician-card-container-zone',
  CHECKUP_TYPE_ITEM_DESKTOP_STEP_TYPE_CARD_CONTAINER_ZONE = 'checkup-type-item-desktop-step-type-card-container-zone',
  CHECKUP_TYPE_ITEM_INITIAL_DATE_MOBILE_CARD_CONTAINER_ZONE = 'checkup-type-item-initial-date-mobile-card-container-zone',
  CHECKUP_TYPE_LIST_EXPANDER = 'checkup-type-list-expander',
  DECK_CHECKUP_TYPE_LIST = 'deck-checkup-type-list',
  FETCH_CHECKUP_TYPE_ITEMS_LIST = 'fetch-checkup-type-items-list',
  FIELD_CHECKUP_TYPE_LIST_TITLE = 'field-checkup-type-list-title',
  FIELD_DESKTOP_CHECKUP_TYPE_ITEM_DESCRIPTION = 'field-desktop-checkup-type-item-description',
  FIELD_DESKTOP_CHECKUP_TYPE_ITEM_EXPECTED_DATE = 'field-desktop-checkup-type-item-expected-date',
  FIELD_DESKTOP_CHECKUP_TYPE_ITEM_PHYSICIAN = 'field-desktop-checkup-type-item-physician',
  FIELD_DESKTOP_CHECKUP_TYPE_ITEM_STEP_TYPE = 'field-desktop-checkup-type-item-step-type',
  FIELD_MOBILE_CHECKUP_TYPE_ITEM_DESCRIPTION = 'field-mobile-checkup-type-item-description',
  FIELD_MOBILE_CHECKUP_TYPE_ITEM_EXPECTED_DATE = 'field-mobile-checkup-type-item-expected-date',
  FIELD_MOBILE_CHECKUP_TYPE_ITEM_PHYSICIAN = 'field-mobile-checkup-type-item-physician',
  FIELD_MOBILE_CHECKUP_TYPE_ITEM_STEP_TYPE = 'field-mobile-checkup-type-item-step-type',
  LAYOUT_CHECKUP_TYPE_ITEMS_LIST = 'layout-checkup-type-items-list',
  MAPPER_DESKTOP_CHECKUP_TYPE_ITEMS_LIST = 'mapper-desktop-checkup-type-items-list',
  PANEL_CHECKUP_TYPE_ITEMS = 'panel-checkup-type-items',
  PANEL_EXPANDABLE_DESKTOP_CHECKUP_TYPE_LIST = 'panel-expandable-desktop-checkup-type-list',
  TEXT_CHECKUP_TYPE_LIST_TITLE = 'text-checkup-type-list-title',
  TEXT_DESKTOP_CHECKUP_TYPE_ITEM_DESCRIPTION = 'text-desktop-checkup-type-item-description',
  TEXT_DESKTOP_CHECKUP_TYPE_ITEM_EXPECTED_DATE = 'text-desktop-checkup-type-item-expected-date',
  TEXT_DESKTOP_CHECKUP_TYPE_ITEM_PHYSICIAN = 'text-desktop-checkup-type-item-physician',
  TEXT_DESKTOP_CHECKUP_TYPE_ITEM_STEP_TYPE = 'text-desktop-checkup-type-item-step-type',
  TEXT_MOBILE_CHECKUP_TYPE_ITEM_DESCRIPTION = 'text-mobile-checkup-type-item-description',
  TEXT_MOBILE_CHECKUP_TYPE_ITEM_EXPECTED_DATE = 'text-mobile-checkup-type-item-expected-date',
  TEXT_MOBILE_CHECKUP_TYPE_ITEM_PHYSICIAN = 'text-mobile-checkup-type-item-physician',
  TEXT_MOBILE_CHECKUP_TYPE_ITEM_STEP_TYPE = 'text-mobile-checkup-type-item-step-type',
}
export { CheckupTypeItemsListAliases };
